import { createSlice } from "redux-starter-kit";

const initialState = {
    captureType: null,
    designerId: null,
    designerName: null,
    next: null,
    open: false,
    productId: null,
    registrationReason: null,
    searchGender: null,
    searchTerm: null,
};

const emailCaptureOverlay = createSlice({
    slice: "emailCaptureOverlay",
    initialState,
    reducers: {
        openEmailCaptureOverlay(state, action) {
            state.captureType = action.payload.captureType;
            state.designerId = action.payload.designerId;
            state.designerName = action.payload.designerName;
            state.next = action.payload.next;
            state.open = true;
            state.productId = action.payload.productId;
            state.registrationReason = action.payload.registrationReason;
            state.searchGender = action.payload.searchGender;
            state.searchTerm = action.payload.searchTerm;
        },
        closeEmailCaptureOverlay(state) {
            state.captureType = null;
            state.designerId = null;
            state.designerName = null;
            state.next = null;
            state.open = false;
            state.productId = null;
            state.registrationReason = null;
            state.searchGender = null;
            state.searchTerm = null;
        },
    },
});

// Extract the action creators object and the reducer
const { actions, reducer } = emailCaptureOverlay;
// Extract and export each action creator by name
export const { openEmailCaptureOverlay, closeEmailCaptureOverlay } = actions;
// Export the reducer, either as a default or named export
export default reducer;
